/**
 *
 * 执行 登录成功之后 预设的命令
 * */
import { dispatch } from "./tools";
import {
  LoginSuccessCommand,
  parseLoginSuccessAction,
  STORAGE_LOGIN_SUCCESS_COMMAND_AFTER,
  STORAGE_TOKEN_KEY,
} from "@/const";

const storedLoginSuccessAction = sessionStorage.getItem(
  STORAGE_LOGIN_SUCCESS_COMMAND_AFTER,
);

if (storedLoginSuccessAction) {
  sessionStorage.removeItem(STORAGE_LOGIN_SUCCESS_COMMAND_AFTER);
}

const loginSuccessAction = parseLoginSuccessAction(storedLoginSuccessAction);

if (loginSuccessAction && localStorage.getItem(STORAGE_TOKEN_KEY)) {
  switch (loginSuccessAction.command) {
    case LoginSuccessCommand.openBuyGroupVipPop: {
      dispatch({ type: "groupVip/set", payload: { showGroupVipBuyPop: true } });

      break;
    }

    case LoginSuccessCommand.resumeHomePrompt: {
      dispatch({
        type: "chatInput/setPendingLoginHomePrompt",
        payload: loginSuccessAction.payload,
      });

      break;
    }

    default:
      break;
  }
}
